import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "../Hooks";
import { getGroups } from "../../requests/groupManagementRequests";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";

const GroupsPage = () => {
	const navigate = useNavigate();
	const { pid } = useParams();

	const result = useQuery({
		queryID: "groups",
		request: getGroups,
		queryVariables: { pid, adminPage: true },
		forcedFilters: {},
		skip: !pid,
	});

	const onCardClick = (id) => {
		navigate(`/Group/${id}`);
	};

	const getIcon = (pid) => {
		switch (pid) {
			case 9:
				return "faUserAstronaut";
			case 5:
				return "faUserTie";
			case 1:
				return "faUserCheck";
			default:
				return "faPeopleGroup";
		}
	};

	const gridData = useMemo(() => {
		if (!result.data?.rows) return null;
		return result.data?.rows.map(({ id, name, description, pid }) => ({
			key: id,
			id,
			title: name,
			subtitle: description,
			iconName: getIcon(pid),
		}));
	}, [result]);

	return (
		<>
			<PageWrapper>
				<Table
					createLink={() => navigate("/Group/create")}
					createButtonText="Create Group"
					createButtonIcon="faUserGroup"
					title="Group Management"
					backButtonLink="/Administration"
					gridData={gridData}
					hideProperties
					hidePager
					hideSearch
					isLoading={result.isLoading}
					hideToggle
					forceGrid
					onCardClick={(group) => onCardClick(group.id)}
				/>
			</PageWrapper>
		</>
	);
};

export default GroupsPage;
